export type UCCLookupTypes = 'lookups' | 'providers' | 'services' | 'providericons'

export type UCCViewTypes = 'findchecks' | 'findpayments' | 'lastpayments' | 'queue'

export type UCCOperTypes = 'debt' | 'pay' | 'comm' | 'changestatus' | 'send'

export enum UCCServiceErrorCode {
  GENERAL,
}

export interface UCCFailure {
  message: string
}
